import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import * as React from 'react';

const SvgGb48Rounded = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  "aria-label": "Great Britain",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#e7e7e7",
  d: "M12 22A10 10 0 1 0 2 12a10 10 0 0 0 10 10z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M12 22A10 10 0 1 0 2 12a10 10 0 0 0 10 10"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#c02e32",
  d: "M14 21.76V14h7.8a10.2 10.2 0 0 0 .2-2 9.5 9.5 0 0 0-.21-2h-7.63C14 10 14 10 14 9.83V2.21A8 8 0 0 0 12.28 2h-.54a9 9 0 0 0-1.74.2v7.73a.07.07 0 0 1-.07.07H2.22A9.4 9.4 0 0 0 2 12a9.3 9.3 0 0 0 .2 2h7.63c.15 0 .15 0 .15.15v7.6a8.4 8.4 0 0 0 1.74.18h.54a8 8 0 0 0 1.74-.17"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#3c3b6e",
  d: "M8.67 8V2.58a10.1 10.1 0 0 0-4.54 3.27c1.47.73 2.94 1.46 4.4 2.21.14.06.14.06.14-.06m6.76.06c1.47-.75 2.95-1.48 4.42-2.22a9.86 9.86 0 0 0-4.55-3.27V8c0 .12 0 .12.13.06M8.55 16l-4.42 2.2a10.1 10.1 0 0 0 4.54 3.27V16c0-.12 0-.12-.12 0m6.75 0v5.4a9.86 9.86 0 0 0 4.55-3.27L15.43 16c-.13-.12-.13-.12-.13 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#c02e32",
  d: "M15.77 8.61a.16.16 0 0 0-.09.06.23.23 0 0 0 .11 0h2.69a.7.7 0 0 0 .28-.07l2.15-1.08a9 9 0 0 0-.68-1.16l-.3.15c-1.38.71-2.76 1.41-4.16 2.1m-7.56 6.78a.14.14 0 0 0 .08-.06H5.5a.64.64 0 0 0-.28.06l-2.14 1.06a9 9 0 0 0 .68 1.16l.24-.14zM5.33 8.66l-.1-.05-2.15-1.08a9 9 0 0 0-.5 1.14h2.66s.05.02.09-.01m13.33 6.67s.06 0 .08.06l2.17 1.09a10 10 0 0 0 .49-1.16h-2.74z"
}));

export { SvgGb48Rounded as default };
//# sourceMappingURL=Gb48Rounded.js.map
